export class Modal {
  constructor() {
    const modalOpenButtons = document.querySelectorAll(".js-modal-open");
    const modalCloseButtons = document.querySelectorAll(".js-modal-close");
    const modals = document.querySelectorAll(".js-modal");

    if (!modalOpenButtons.length || !modalCloseButtons.length || !modals.length) return;

    // モーダルを開く処理
    modalOpenButtons.forEach((button) => {
      const modalId = button.dataset.modalId;
      const dialog = document.getElementById(modalId);

      if (!dialog) return;

      button.addEventListener("click", () => {
        dialog.showModal();
        document.body.classList.add("is-modal-open");
        requestAnimationFrame(() => {
          dialog.classList.add("is-show");
        });
      });
    });

    // モーダルを閉じる関数
    const closeModal = (dialog) => {
      if (!dialog.classList.contains("is-show")) return;
      dialog.classList.remove("is-show");

      const onTransitionEnd = () => {
        dialog.close();
        dialog.removeEventListener("transitionend", onTransitionEnd);
      };

      dialog.addEventListener("transitionend", onTransitionEnd);
    };

    // 閉じるボタンで閉じる
    modalCloseButtons.forEach((button) => {
      const dialog = button.closest("dialog");
      if (!dialog) return;

      button.addEventListener("click", () => closeModal(dialog));
    });

    // 背景クリックで閉じる
    modals.forEach((dialog) => {
      dialog.addEventListener("click", (e) => {
        if (e.target === dialog) {
          closeModal(dialog);
        }
      });

      // 閉じたらbodyのクラスを外す（ESCキーでの閉じるも含む）
      dialog.addEventListener("close", () => {
        dialog.classList.remove("is-show");
        document.body.classList.remove("is-modal-open");
      });
    });
  }
}


